export var DrawType;
(function (DrawType) {
    DrawType[DrawType["DrawArray"] = 0] = "DrawArray";
    DrawType[DrawType["DrawArrayInstance"] = 1] = "DrawArrayInstance";
    DrawType[DrawType["DrawArrayIndirect"] = 2] = "DrawArrayIndirect";
    DrawType[DrawType["DrawElement"] = 3] = "DrawElement";
    DrawType[DrawType["DrawElementInstance"] = 4] = "DrawElementInstance";
    DrawType[DrawType["DrawElementIndirect"] = 5] = "DrawElementIndirect";
})(DrawType || (DrawType = {}));
